"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/importservice/v1/api/import";
var config = {
  recordImport: serviceURL + "/record",
  fundImport: serviceURL + "/fund",
  fundPerformanceImport: serviceURL + "/fund/performance",
  fundImpactImport: serviceURL + "/fund/impact",
  fundDonorsImport: serviceURL + "/fund/donors",
  fundTypeImport: serviceURL + "/fund/type",
  userImport: serviceURL + "/user",
  templateFileImport: "/importservice/v1/api/template/file"
};
exports.config = config;